import AddOms from "../components/omslist/AddOms";

const AddOmsPage = () =>{
    return(
        <AddOms/>
    )
}

export default AddOmsPage;